<template>
  <Chart
    type="horizontalBar"
    :width="width"
    :height="height"
    :data="data"
    :options="options"
  />
</template>

<script>
import { defineComponent, computed } from 'vue'
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default defineComponent({
  props: {
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    chartLabel:{
      type: Array,
      default: ()=>[]
    },
    seriesData:{
      type: Object,
    },
  },
  setup(props) {
    const data = computed(() => {
      return {
        labels: [
          'ที่อยู่อาศัย',
          'สุขภาพ',
          'การศึกษา',
          'มีงานทำ/รายได้',
          'ครอบครัว',
          'ความรุนแรง',
          'ค้ามนุษย์',
          'การเข้าถึงสิทธิ',
          'อื่นๆ'
        ],
        datasets: [
          {
            label: 'เด็กเล็ก (0 - 6 ปี)',
            barPercentage: 0.5,
            barThickness: 20,
            maxBarThickness: 30,
            minBarLength: 0,
            backgroundColor: '#945050',
            data: getDataByCategory('youngchildstats')
          },
          {
            label: 'เด็ก (6 ปีขึ้นไป - 12 ปี)',
            barPercentage: 0.5,
            barThickness: 20,
            maxBarThickness: 30,
            minBarLength: 0,
            backgroundColor: '#E0E0A6',
            data: getDataByCategory('childstats')
          },
          {
            label: 'เยาวชน (12 ปีขึ้นไป - 18 ปี)',
            barPercentage: 0.5,
            barThickness: 20,
            maxBarThickness: 30,
            minBarLength: 0,
            backgroundColor: '#E09090',
            data: getDataByCategory('adolescencestats')
          },
          {
            label: 'วัยผู้ใหญ่ (18 ปีขึ้นไป - 59 ปี)',
            barPercentage: 0.5,
            barThickness: 20,
            maxBarThickness: 30,
            minBarLength: 0,
            backgroundColor: '#79B9E0',
            data: getDataByCategory('adultstats')
          },
          {
            label: 'ผู้สูงอายุ (60 ปีขึ้นไป)',
            barPercentage: 0.5,
            barThickness: 20,
            maxBarThickness: 30,
            minBarLength: 0,
            backgroundColor: '#577C94',
            data: getDataByCategory('elderlystats')
          }
        ]
      }
    })
    const options = computed(() => {
      return {
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              let sum = 0;

              tooltipItem.forEach(function(item) {
                sum += item.xLabel;
              });
              return `${data['labels'][tooltipItem[0]['index']]} (รวม: ${new Intl.NumberFormat().format(sum)})`;
            },
          },
          intersect: false
        },
        layout:{
          padding: {
            right: 30
          }
        },
        scales: {
          xAxes: [{
            display: false,
            stacked: true,
          }],
          /*xAxes: [{
            stacked: true,
            min: 0,
            max: 100000,
            ticks: {
              stepSize: 20,
              fontSize: 14
            },
            gridLines: {
              display:false
            },
          }],*/
          yAxes: [{
            stacked: true,
            ticks: {
              fontSize: 14
            },
          }]
        },
        legend: {
            labels: {
              fontSize: 14,
              boxWidth: 6,
              padding: 15,
            },
            position: 'bottom',
            align: "start",
        },
        plugins:{
          datalabels:{
            anchor: 'end',
            align: 'end',
            color: '#14286c',
            font: {
              size: 14,
            },
            formatter: (value, context)=>{
              const datasetArr=[]
              context.chart.data.datasets.forEach((dataset)=>{
                if(dataset.data[context.dataIndex] != undefined){
                  datasetArr.push(dataset.data[context.dataIndex])
                }
              })
              function totalSum(total, datapoint){
                return total + datapoint
              }
              let sum = datasetArr.reduce(totalSum,0)
              if(context.datasetIndex === datasetArr.length - 1)
                return new Intl.NumberFormat().format(sum)
              else
                return ""
            }
          }
        },
        responsive:true,
        maintainAspectRatio:false,
      }
    })

    const getDataByCategory = (cate) =>{
      let result = [0,0,0,0,0,0,0,0,0]
      if(props.seriesData){
        if(props.seriesData[cate]?.length > 0){
          return [props.seriesData[cate][0].prob_housing, props.seriesData[cate][0].prob_health, props.seriesData[cate][0].prob_education, props.seriesData[cate][0].prob_occupation, props.seriesData[cate][0].prob_family, props.seriesData[cate][0].prob_violence, props.seriesData[cate][0].prob_human_trafficking, props.seriesData[cate][0].prob_accessibility, props.seriesData[cate][0].prob_others]
        }
      }
      return result
    }
    return {
      data,
      options,
      ChartDataLabels
    }
  }
})
</script>
